// extracted by mini-css-extract-plugin
export default {"root":"animated_root__qIDR2","shake":"animated_shake__dRwf6"};